/* fs-mobilebar.js — the mobile bottom bar, its overlays, and the cart pill label.

   ⚠ RECONSTRUCTED 2026-09-06. The original was overwritten in error. This file
   was rebuilt from fs-mobilebar.css's contract and fs-menu-click.js's DOM notes,
   so the MARKUP it emits is exact but the wiring is a re-derivation. Shopify
   admin keeps per-file version history (Themes -> Edit code -> this file ->
   "Older versions"); that is the only true revert.

   Builds the three cells fs-mobilebar.css lays out (1fr 1fr 58px): two
   button.fs-mbar__item (each holding span.fs-mbar__label + span.fs-mbar__arrow)
   and button.fs-mbar__pill.fs-mbar__menu.

   THE PILLS ARE MIRRORED FROM THE DESKTOP NAV, NOT HARD-CODED — Ezra asked to
   "match the pills from desktop", and a copy of the menu in here would drift the
   first time someone edits a linklist in admin.

   ⚠ READ THE PANELS FROM .navigation--main, NOT .navigation--left. The theme
   renders the desktop nav twice: --left is the visible proxy bar and --main
   holds the tier-2 panels (fs-megamenu.js relies on the same split). Reading
   --left alone yields labels with no children and produces two empty overlays.
   We score both copies and take whichever gives the most complete items.

   ⚠ NO href ON THE BAR ITEMS. Both tier-1 parents already appear as the first
   entry of their own panel — see the flip-flop note in fs-menu-click.js.

   ⚠ THE BAR IS z-20 AND THE OVERLAY z-19, deliberately: the bar stays on top of
   its own overlay so the item that opened it can close it. Do not "fix" that. */
(function () {
  var WITH_CHILDREN = 'navigation__item--with-children';
  var LISTS = 'main-navigation .navigation--main .navigation__tier-1,' +
              ' .navigation--left .navigation__tier-1';

  var bar = null;
  var openItem = null;
  var openOverlay = null;

  /* ---- reading the desktop nav -------------------------------------------- */
  function readItems() {
    var lists = document.querySelectorAll(LISTS);
    var best = [];
    for (var i = 0; i < lists.length; i++) {
      var out = [];
      var kids = lists[i].children;
      for (var j = 0; j < kids.length; j++) {
        var li = kids[j];
        if (!li.classList || !li.classList.contains(WITH_CHILDREN)) continue;
        var label = li.querySelector(':scope > .navigation__link');
        var links = li.querySelectorAll('.navigation__tier-2 > .navigation__item > .navigation__link');
        var title = label ? (label.textContent || '').trim() : '';
        if (!title || !links.length) continue;
        out.push({ title: title, links: links });
      }
      if (out.length > best.length) best = out;
    }
    return best;
  }

  /* ---- open / closed ------------------------------------------------------ */
  function closeAll() {
    if (openItem) {
      openItem.classList.remove('fs-mbar__item--open');
      openItem.setAttribute('aria-expanded', 'false');
    }
    if (openOverlay) openOverlay.classList.remove('fs-mov--open');
    openItem = null;
    openOverlay = null;
    document.documentElement.classList.remove('fs-mov-lock');
  }

  function toggle(item, overlay) {
    if (openItem === item) { closeAll(); return; }
    closeAll();
    openItem = item;
    openOverlay = overlay;
    item.classList.add('fs-mbar__item--open');
    item.setAttribute('aria-expanded', 'true');
    overlay.classList.add('fs-mov--open');
    document.documentElement.classList.add('fs-mov-lock');
  }

  /* The theme's delegated handler on .mobile-nav-toggle is a TOGGLE, so a
     synthetic click on it CLOSES an already-open drawer. theme.openMobileNav()
     is the idempotent entry point; the click is only a fallback. */
  function openDrawer() {
    closeAll();
    if (window.theme && typeof window.theme.openMobileNav === 'function') {
      window.theme.openMobileNav();
      return;
    }
    var toggleEl = document.querySelector('.mobile-nav-toggle');
    if (toggleEl) toggleEl.click();
  }

  /* ---- building ----------------------------------------------------------- */
  function buildOverlay(data, id) {
    var overlay = document.createElement('div');
    overlay.className = 'fs-mov';
    overlay.id = id;

    var head = document.createElement('div');
    head.className = 'fs-mov__head';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'fs-mov__close';
    close.setAttribute('aria-label', 'Close menu');
    close.addEventListener('click', closeAll);
    head.appendChild(close);

    var list = document.createElement('ul');
    list.className = 'fs-mov__list';

    Array.prototype.forEach.call(data.links, function (source) {
      var text = (source.textContent || '').trim();
      var href = source.getAttribute('href');
      if (!text || !href) return;
      var li = document.createElement('li');
      li.className = 'fs-mov__item';
      var link = document.createElement('a');
      link.className = 'fs-mov__link';
      link.href = href;
      link.textContent = text;
      li.appendChild(link);
      list.appendChild(li);
    });

    overlay.appendChild(head);
    overlay.appendChild(list);
    document.body.appendChild(overlay);
    return overlay;
  }

  function buildBar(items) {
    bar = document.createElement('nav');
    bar.className = 'fs-mbar';
    bar.setAttribute('aria-label', 'Sections');

    /* Two, because the grid is 1fr 1fr 58px. If a third parent is ever added to
       the desktop nav it will NOT appear here until that grid grows — see the
       label-width arithmetic in fs-mobilebar.css before widening it. */
    items.slice(0, 2).forEach(function (data, index) {
      var id = 'fs-mov-' + index;
      var overlay = buildOverlay(data, id);

      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'fs-mbar__item';
      item.setAttribute('aria-expanded', 'false');
      item.setAttribute('aria-controls', id);

      var label = document.createElement('span');
      label.className = 'fs-mbar__pill fs-mbar__label';
      label.textContent = data.title;

      var arrow = document.createElement('span');
      arrow.className = 'fs-mbar__pill fs-mbar__arrow';
      arrow.setAttribute('aria-hidden', 'true');

      item.appendChild(label);
      item.appendChild(arrow);
      item.addEventListener('click', function (e) {
        e.preventDefault();
        toggle(item, overlay);
      });

      bar.appendChild(item);
    });

    var menu = document.createElement('button');
    menu.type = 'button';
    menu.className = 'fs-mbar__pill fs-mbar__menu';
    menu.setAttribute('aria-label', 'Menu');
    menu.addEventListener('click', openDrawer);
    bar.appendChild(menu);

    document.body.appendChild(bar);
  }

  /* ---- the light state over the hero -------------------------------------- */
  /* Keyed on geometry rather than on the template, because the hero is a
     section that can be moved or removed in the customizer. The bar goes white
     only while its own midline is inside a video section's box.

     ⚠ NEVER GUARD A FIXED ELEMENT WITH offsetParent. It is null for
     `position: fixed` in every browser, visible or not — so an
     `if (!bar.offsetParent) return` here silenced this function outright and
     the bar stayed grey over the hero video. Caught 2026-09-06 from a phone
     screenshot, not from the DOM: at desktop widths the early return was
     CORRECT for the wrong reason, so nothing looked broken while testing.
     Measure instead — above 767 the bar is display:none and its rect is 0 tall,
     which is the check that actually means "not on screen". */
  function updateLight() {
    if (!bar) return;
    var box = bar.getBoundingClientRect();
    if (!box.height) return;
    var mid = box.top + box.height / 2;
    var zones = document.querySelectorAll('.section-background-video');
    var light = false;
    for (var i = 0; i < zones.length; i++) {
      var z = zones[i].getBoundingClientRect();
      if (z.top <= mid && z.bottom >= mid) { light = true; break; }
    }
    if (bar.classList.contains('fs-mbar--light') !== light) {
      bar.classList.toggle('fs-mbar--light', light);
    }
  }

  /* ---- the cart pill label ------------------------------------------------ */
  /* Mirrored off the desktop segment fs-header.js maintains, NOT recomputed —
     one place counts the cart, so the two pills can never disagree. The !==
     guard is load-bearing: the observer below watches the header, so writing
     unconditionally would re-enter this function forever. */
  function syncCart() {
    var source = document.querySelector('.fs-nav-action--cart .navigation__link');
    if (!source) return;
    var text = (source.textContent || '').trim();
    if (!text) return;
    var targets = document.querySelectorAll('.logo-area__right__inner a.cart-link .cart-link__label');
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].textContent !== text) targets[i].textContent = text;
    }
  }

  /* setTimeout, not rAF: a backgrounded tab freezes the frame timeline and the
     label would come back from bfcache showing the pre-add count. */
  function scheduleCart() {
    setTimeout(syncCart, 0);
    setTimeout(syncCart, 300);
  }

  function watchCart() {
    ['on:cart:add', 'on:cart:change', 'on:cart:error', 'on:cart:after-merge']
      .forEach(function (name) { document.addEventListener(name, scheduleCart); });
    window.addEventListener('pageshow', scheduleCart);

    /* The theme REPLACES .cart-link when the header re-renders, so an observer
       on the link itself ends up on a detached node. Watch the section. */
    var link = document.querySelector('.cart-link');
    var host = link && link.closest ? link.closest('.shopify-section') : null;
    if (host && window.MutationObserver) {
      new MutationObserver(scheduleCart)
        .observe(host, { childList: true, subtree: true, characterData: true });
    }
  }

  /* ---- init --------------------------------------------------------------- */
  function init() {
    if (document.querySelector('.fs-mbar')) return;

    var items = readItems();
    if (items.length) buildBar(items);

    if (bar) {
      window.addEventListener('scroll', updateLight, { passive: true });
      window.addEventListener('resize', updateLight);
      window.addEventListener('orientationchange', updateLight);
      updateLight();
      setTimeout(updateLight, 600);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) closeAll();
    });

    /* The drawer and an overlay must never be open together — the CSS hides the
       bar under body.reveal-mobile-nav, which would strand an open overlay with
       nothing left to close it. */
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (document.body.classList.contains('reveal-mobile-nav') && openOverlay) closeAll();
      }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    watchCart();
    scheduleCart();
    setTimeout(scheduleCart, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
